import React, { useState, useEffect } from 'react';
import LandingMantenimiento from '../../pages/LandingMantenimiento';
import { getDoc, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { useLocation } from 'react-router-dom';

// CONFIGURACIÓN
const MODO_MANTENIMIENTO_POR_DEFECTO = true; // Si no hay conexión o config, asumimos mantenimiento
const MIS_EMAILS_PERMITIDOS = [
    'admin@visiopadel.com', 
    'javier@masquefotocopias.es',
    '98765432100@gmail.com'
];

const MaintenanceGate = ({ children }) => {
    const [maintenanceMode, setMaintenanceMode] = useState(MODO_MANTENIMIENTO_POR_DEFECTO);
    const [isAllowedUser, setIsAllowedUser] = useState(false);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    // 1. Efecto para escuchar la configuración de Firebase en tiempo real
    useEffect(() => {
        const configRef = doc(db, 'configuracion', 'general');
        
        const unsubscribe = onSnapshot(configRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.data();
                // Si el campo existe, lo usamos. Si no, usamos el por defecto.
                setMaintenanceMode(data.modoMantenimiento !== undefined ? data.modoMantenimiento : MODO_MANTENIMIENTO_POR_DEFECTO);
                console.log("🔄 [MaintenanceGate] Estado actualizado desde Firebase:", data.modoMantenimiento);
            } else {
                console.log("⚠️ [MaintenanceGate] No se encontró config en Firebase, usando default:", MODO_MANTENIMIENTO_POR_DEFECTO);
                setMaintenanceMode(MODO_MANTENIMIENTO_POR_DEFECTO);
            }
            setLoading(false);
        }, (error) => {
            console.error("❌ [MaintenanceGate] Error escuchando config:", error);
            // En caso de error, mantenemos el estado local o el último conocido
            setLoading(false); 
        });

        return () => unsubscribe();
    }, []);

    // 2. Efecto para verificar permisos de usuario (se ejecuta al cambiar de ruta)
    useEffect(() => {
        const checkUserAccess = () => {
             const userEmail = localStorage.getItem('userEmail');
             if (userEmail && MIS_EMAILS_PERMITIDOS.includes(userEmail)) {
                 console.log("🔓 [MaintenanceGate] Usuario VIP detectado:", userEmail);
                 setIsAllowedUser(true);
             } else {
                 setIsAllowedUser(false);
             }
        };
        checkUserAccess();
    }, [location]);

    // Si estamos cargando, mostramos un spinner o nada (para evitar parpadeos)
    if (loading) return <div className="min-h-screen bg-slate-900 flex items-center justify-center text-white">Cargando...</div>;

    // EXCEPCIÓN CRÍTICA: La página de login SIEMPRE debe ser accesible para poder entrar
    if (location.pathname === '/login') return children;

    // LÓGICA FINAL:
    // Si NO está en mantenimiento -> Muestra la web (children)
    if (!maintenanceMode) return children;

    // Si SÍ está en mantenimiento, pero el usuario es VIP -> Muestra la web (children)
    if (maintenanceMode && isAllowedUser) return children;

    // Si está en mantenimiento y NO es VIP -> Muestra Landing
    return <LandingMantenimiento />;
};

export default MaintenanceGate;
